module.exports = __webpack_public_path__ + "img/dream-journal_B095GRVZSW.f45e3212.jpg";